import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://daalzarjctdhuuokmvcd.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_6kKEpEUK8nHh4jVsRIEXLA_voLHsPQr';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
